import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoursesData } from './coursesData';

const routes: Routes = [
  {
    path: 'courses',
    component: CoursesData,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoursesDataRoutingModule {}
